import React, { useContext } from 'react';
import set from 'lodash/set';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import FormContext from 'src/presentation/contexts/FormContext';
import { MultiSelectDropdownMenu } from 'src/presentation/components/agent_desktop_components';

type MappingToSelectorProps = {
  'data-aid': string;
  attr: string;
  options: Array<{ label: string; value: string }>;
  placeholder?: string;
};

const MappingToSelector = ({ attr, 'data-aid': dataAid, options, placeholder }: MappingToSelectorProps) => {
  const { workingState, updateState, resetError, errors } = useContext(FormContext);

  const error = errors.find(err => err.attr === attr);

  const handleSelect = (value: unknown) => {
    updateState(set({}, attr, value));

    if (error && !isEmpty(value)) {
      resetError({ attr, errors });
    }
  };

  const values = get(workingState, attr) || [];

  return (
    <MultiSelectDropdownMenu
      data-aid={dataAid}
      options={options}
      values={values}
      onSelect={handleSelect}
      placeholder={placeholder}
      isError={!!error}
    />
  );
};

export default MappingToSelector;
